module.exports = __webpack_public_path__ + "img/Videopublicity-imgtest.302c9fca.png";